"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNKNOWN_STRING = exports.UNKNOWN_OBJECT_ID = exports.UNKNOWN_NUMBER = exports.D_COORD_VALUE = void 0;
var UNKNOWN_STRING = "";
exports.UNKNOWN_STRING = UNKNOWN_STRING;
var UNKNOWN_NUMBER = 0;
exports.UNKNOWN_NUMBER = UNKNOWN_NUMBER;
var UNKNOWN_OBJECT_ID = UNKNOWN_NUMBER;
exports.UNKNOWN_OBJECT_ID = UNKNOWN_OBJECT_ID;
var D_COORD_VALUE = UNKNOWN_NUMBER;
exports.D_COORD_VALUE = D_COORD_VALUE;